import { Box, type BoxProps, useTheme } from '@mui/material';
import type { FC } from 'react';

export const SlabCard: FC<BoxProps> = ({ sx, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginY: 2,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 1.5,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.SlabGray.Stroke}`,
        backgroundColor: theme.palette.SlabGray[0],
        ...sx,
      }}
      {...props}
    />
  );
};
